import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import DigitalMarketingCoimbatore from "../components/blogs/DigitalMarketingCoimbatore";

const DigitalMarketingAgencyCoimbatore = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.search) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Top Digital Marketing Companies in Coimbatore | SMS ZOO ZOO</title>
        <meta
          name="description"
          content="Among the leading digital marketing companies in Coimbatore, SMS ZOO ZOO delivers ROI-focused SEO, ads, and performance marketing services."
        />

        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.smszoozoo.com/digital-marketing-agency-Coimbatore"
        />
      </Helmet>

      <Navbar />
      <DigitalMarketingCoimbatore />
      <Footer />
    </>
  );
};

export default DigitalMarketingAgencyCoimbatore;
